import React from 'react';

import stylesheet from './StyledIcon.module.scss';

interface Props {
  /**
   * Using `any` type to avoid conflicts with @svgr/webpack plugin or babel-plugin-inline-react-svg plugin.
   * This is recommended by [NextJS Image Types](./node_modules/next/image-types/global.d.ts).
   */
  icon?: any // eslint-disable-line @typescript-eslint/no-explicit-any
  classList?: string

  /*
  This prop allows a classlist to be passed in that also comes with some automatic styles that are needed
  for cross-browser compatibility. Just set `--svg-icon-fill-color` and `--svg-icon-size` in the class you
  pass to this prop.
  */
  withStandardIconClasses?: string
}

const StyledIcon: React.FC<Props> = ({
  icon,
  classList,
  withStandardIconClasses,
}) => {
  const styles = `${classList || ''} ${withStandardIconClasses ? stylesheet.icon + ' ' + withStandardIconClasses : ''}`.trim();
  const Icon = icon;

  return (
    <Icon aria-hidden='true' className={styles} />
  );
};

export default StyledIcon;
